import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-completed-ring',
  templateUrl: 'completed-ring.component.html'
})
export class CompletedRingComponent {
  constructor() {}
}
